/** @file Texture page of the RenderBuffers draw that contains a given index position. */
import { RENDER_LAYOUT } from '@pose2d/geometry/renderBuffers';
import type { RenderBuffers } from '@pose2d/geometry/types';
import { readNum } from './readNum';

const D = RENDER_LAYOUT.DRAW_STRIDE;

/** Page index of the draw whose index range holds position t, or -1 when no draw covers it. */
export function drawPageAt(buffers: RenderBuffers, t: number): number {
  for (let d = 0; d < buffers.drawCount; d++) {
    const start = readNum(buffers.draws, d * D + 2);
    if (t >= start && t < start + readNum(buffers.draws, d * D + 3)) return readNum(buffers.draws, d * D);
  }
  return -1;
}
